"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._rxjs@5.4.3@rxjs/util/isFunction.js
// module id = ../../../../._rxjs@5.4.3@rxjs/util/isFunction.js
// module chunks = 5